import styled from "styled-components"

export const HeaderContainer = styled.div`
    display: block;
    margin: 0 auto;
    max-width: 800px;
    align-items: center;
    color: #969696;
    justify-content: center;
    text-align: center;
    margin-top: 130px;
    margin-bottom: 170px;
`;

export const HeaderTitle = styled.p`
    font-size: 17px;
    font-weight: normal;
    color: #BB86FC;
    align-items: baseline;
    
    @media (max-width: 600px) { 
        font-size: 15px;
    }
`;


export const HeaderSubTitle = styled.p`
    margin: 15px;
    font-size: 50px;
    font-weight: bold;
    color: #f2f2f2;

    @media (max-width: 600px) { 
        font-size: 35px;
    }
`;

export const EmailContainer = styled.div`
    margin-top: 50px;

    
    @media (max-width: 600px) { 
        font-size: 40px;
    }
`;

export const Email = styled.a`
    margin: 30px auto;
    width: 100px;
    padding: 15px 28px;
    text-align: center;
    font-size: 15px;
    border: solid 1px #BB86FC;
    border-radius: 5px;
    color: #BB86FC;
    cursor: pointer;
    text-decoration: none;

    &:hover{
        background-color: rgba(255,255,255, 0.05)
    }
    
    @media (max-width: 600px) { 
        font-size: 14px;
    }
    
`;

export const Description = styled.div`
    margin: 0 auto;
    max-width: 500px;
    padding: 0 30px;
    text-align: center;
`;

